
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface RecentOrder {
  id: string;
  receiptId: string;
  customerName: string;
  productName: string;
  status: string;
  totalAmount: number;
  currencyCode: string;
  date: string;
}

interface RecentOrdersProps {
  recentOrders: RecentOrder[];
  isConnected: boolean;
  isLoading: boolean;
  formatRevenue: (amount: number, currency: string) => string;
}

const RecentOrders = ({ recentOrders, isConnected, isLoading, formatRevenue }: RecentOrdersProps) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'shipped':
        return 'bg-green-50 text-green-700';
      case 'processing':
        return 'bg-yellow-50 text-yellow-700';
      case 'new':
        return 'bg-blue-50 text-blue-700';
      default:
        return 'bg-gray-50 text-gray-700';
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Orders</CardTitle>
        <CardDescription>
          {isConnected ? "Latest orders from your Etsy store" : "Connect Etsy to see your orders"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {!isConnected ? (
          <p className="text-gray-500 text-center py-4">
            Connect your Etsy store to see recent orders
          </p>
        ) : recentOrders.length === 0 ? (
          <p className="text-gray-500 text-center py-4">
            {isLoading ? "Loading orders..." : "No orders found"}
          </p>
        ) : (
          <div className="space-y-4">
            {recentOrders.map((order) => (
              <div key={order.id} className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{order.productName}</p>
                  <p className="text-sm text-gray-600">
                    Order #{order.receiptId} • {order.customerName}
                  </p>
                  <p className="text-xs text-gray-500">
                    {formatRevenue(order.totalAmount, order.currencyCode)}
                  </p>
                </div>
                <Badge variant="outline" className={getStatusColor(order.status)}>
                  {order.status}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentOrders;
